/* ===========================================================
THNWHN
WORN BY HUMANS
=========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    /* ---------------------------------------
       DESKTOP REVEAL
    --------------------------------------- */

    const cards = document.querySelectorAll(".wbh__card");

    const observer = new IntersectionObserver((entries)=>{

        entries.forEach((entry,index)=>{

            if(entry.isIntersecting){

                setTimeout(()=>{

                    entry.target.classList.add("in-view");

                },index*80);

            }

        });

    },{
        threshold:.18
    });

    cards.forEach(card=>observer.observe(card));



    /* ---------------------------------------
       IMAGE LOADED
    --------------------------------------- */

    document.querySelectorAll(".wbh__image").forEach(img=>{

        if(img.complete){

            img.classList.add("loaded");

        }else{

            img.onload=()=>{

                img.classList.add("loaded");

            }

        }

    });



    /* ---------------------------------------
       MOBILE ROW MOMENTUM
    --------------------------------------- */

    document.querySelectorAll(".wbh__mobile-row").forEach(row=>{

        let isDown=false;

        let startX;

        let scrollLeft;

        row.addEventListener("mousedown",(e)=>{

            isDown=true;

            startX=e.pageX-row.offsetLeft;

            scrollLeft=row.scrollLeft;

        });

        row.addEventListener("mouseleave",()=>{

            isDown=false;

        });

        row.addEventListener("mouseup",()=>{

            isDown=false;

        });

        row.addEventListener("mousemove",(e)=>{

            if(!isDown) return;

            e.preventDefault();

            const x=e.pageX-row.offsetLeft;

            const walk=(x-startX)*1.4;

            row.scrollLeft=scrollLeft-walk;

        });

    });



    /* ---------------------------------------
       SUBTLE PARALLAX
    --------------------------------------- */

    if(window.innerWidth>990){

        const hero=document.querySelector(".wbh__card--hero");

        if(hero){

            window.addEventListener("scroll",()=>{

                const y=window.scrollY*0.04;

                hero.querySelector(".wbh__image").style.transform=

                `translateY(${y}px) scale(1.03)`;

            });

        }

    }

});